/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import moment from 'moment';
import DataType from '@linc-technologies/linced-common/enums/data-type';

export default class Unenrol extends Component {
  @tracked
  step = 0;

  @action
  setStep(value) {
    this.step = value;
  }

  @tracked
  endDate = '';

  @action
  setEndDate(value) {
    this.endDate = value;
  }

  editing = false;

  @tracked
  unenrolling = false;

  @tracked
  reason;

  @action
  setReason(value) {
    this.reason = value;
  }

  @tracked
  destinationSchool;

  @action
  setDestinationSchool(value) {
    this.destinationSchool = value;
  }

  get isPending() {
    let endDate = moment(this.endDate);
    let now = moment();
    return endDate.isAfter(now, 'd');
  }

  didReceiveAttrs() {
    this.endDate = this.enrolment.exitDate;
    if (isEmpty(this.enrolment.meta)) {
      this.enrolment.set('meta', {});
    }

    let reason = this.enrolment.departureReason;
    let destinationSchool = this.enrolment.meta.get(
      'fields.international:destinationSchool.value',
    );

    this.reason = reason;
    this.destinationSchool = destinationSchool;

    return super.didReceiveAttrs(...arguments);
  }

  @action
  unenrol() {
    this.unenrolling = true;
    // Update the enrolment record before saving to ensure that we don't accidentally wipe anything
    // which was updated by the Person update in the previous step.
    this.enrolment.reload().then((enrolment) => {
      let endDate = moment(this.endDate);

      // Initialise dynamic fields
      if (isEmpty(this.enrolment.meta)) {
        this.enrolment.set('meta', {});
      }

      let destinationSchool = enrolment.meta.get(
        'fields.international:destinationSchool',
      );
      if (isEmpty(destinationSchool)) {
        enrolment.meta.addField(
          'international:destinationSchool',
          DataType.STRING,
        );
        destinationSchool = enrolment.meta.get(
          'fields.international:destinationSchool',
        );
      }
      // Set core enrolment fields
      let departureReason = isEmpty(this.reason) ? '' : this.reason;
      enrolment.setProperties({
        exitDate: endDate.format('YYYY-MM-DD'),
        departureReason,
      });

      // Update enrolment status, if they've actually left
      if (!this.isPending && !this.editing) {
        enrolment.set('status', EnrolmentStatus.FORMER);
      }
      if (this.destinationSchool) {
        destinationSchool.set('value', this.destinationSchool);
      }

      enrolment.save().then(() => {
        this.unenrolling = false;
        this.step = this.step + 1;
      });
    });
  }
}
